export const uid = (): string => crypto.randomUUID();
